import React from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import PropTypes from 'prop-types';
import CustomTextarea from 'Common/CustomTextArea';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import CustomFileAttachment from 'Common/CustomFileAttachment/CustomFileAttachment';
import PopupHeader from 'Components/PopupHeader/PopupHeader';
import PopupFooter from 'Components/PopupFooter/PopupFooter';


const AddAttachmentPopup = ({ onClose, paymentModel, disableDraggable, validationModel, handleAttachmentChange, handleRemoveAttachment, openViewAttachment, handleApplyPayment, handlePaymentChange }) => {
    const uniqueId = "AddAttachmentPopup"

    return (
        <ReactPortal wrapperId={uniqueId}>
            <div data-te-modal-init className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" aria-modal="true" data-te-open="true">
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div data-te-modal-dialog-ref className="relative w-[500px]   min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg">
                        <div className='p-10 pt-0 '>
                            <PopupHeader uniqueId={uniqueId} heading='Attachments' />
                            <div className=" overflow-y-auto max-h-[70vh]">
                                <div className="grid grid-cols-1 gap-2">
                                    <div>
                                        <CustomFileAttachment
                                            multiple={true}
                                            onFileChange={handleAttachmentChange}
                                            name="paymentAttachment"
                                            onDeleteFile={handleRemoveAttachment}
                                            data={paymentModel.paymentAttachment ?? []}
                                            openViewAttachment={openViewAttachment}
                                            extraClass="col-span-12"

                                        />
                                        {validationModel.errorPaymentAttachment}
                                    </div>
                                    <div className="flex items-center mt-2">
                                        <label className="required">Memo</label>
                                    </div>
                                    <CustomTextarea
                                        placeholder="Memo"
                                        rows={3}
                                        name="notes"
                                        value={paymentModel.notes}
                                        onChange={handlePaymentChange}
                                    ></CustomTextarea>
                                    {validationModel.notes}
                                </div>
                            </div>
                            <PopupFooter onClose={onClose} onConfirm={handleApplyPayment} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default AddAttachmentPopup
AddAttachmentPopup.propTypes = {
    onClose: PropTypes.func.isRequired,
    paymentModel: PropTypes.shape({
        paymentAttachment: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                name: PropTypes.string,
                url: PropTypes.string,
            })
        ),
    }).isRequired,
    handleAttachmentChange: PropTypes.func.isRequired,
    handleRemoveAttachment: PropTypes.func.isRequired,
    openViewAttachment: PropTypes.func.isRequired,
    handleApplyPayment: PropTypes.func.isRequired,
};